
// region JS Imports

// region External modules
import on_domready from "domready"
// endregion External modules

// region Private Modules
import DataRetriever from "app/data_retriever"
// endregion Private Modules

// region Public Components
// endregion Public Components

// region private components
import {
  Factory as ChildrenBuildingsSectionFactory,
} from "./components/children_buildings_section/index"

import {
  Factory as MarketDataOverviewFactory,
} from "./components/market_data_overview/index"

import {
  Factory as SaleListingsFactory,
} from "./components/sale_listings/index"

import {
  Factory as TransactionHistoryFactory,
} from "./components/transaction_history/index"

import {
  Factory as NewDevelopmentAgentSection,
} from "./components/agent_section/index"

import {
  load_and_inject_content as load_and_inject_below_the_fold_section,
} from "./below_the_fold_section"
import $ from "jquery";
// endregion private components

// endregion JS Imports


const init = (): void => {
  const body_el = document.querySelector("body") as HTMLElement

  MarketDataOverviewFactory.instance()

  if ($(".page--building-level-real-estate-transactions-page--agent_section").length > 0) {
    NewDevelopmentAgentSection.instance()
  }

  on_domready(() => {
    const building_id = DataRetriever.get("building-id")
    const current_page_number = DataRetriever.get("current-page-number")

    load_and_inject_below_the_fold_section(building_id, current_page_number)
    .then(() => {
      TransactionHistoryFactory.instance()
      ChildrenBuildingsSectionFactory.instance()
      SaleListingsFactory.instance()

      body_el.classList.add("page--below-the-fold-content-loaded")
    })
    .done()
  })
}


export default {
  init,
}
